import { getBrowserWindow, getRouteBasename } from ".";

export function getBaseRoute() {
  const window = getBrowserWindow();
  if (!window) {
    return;
  }

  const basename = getRouteBasename();
  const protocol =
    PRODUCTION && location.hostname !== "localhost" ? "https" : "http";
  const host = basename ? `${location.host}${basename}` : `${location.host}`;
  const baseRoute = `${protocol}://${host}`;

  return baseRoute;
}
